function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 29C22.508 29 29 22.508 29 14.5S22.508 0 14.5 0 0 6.492 0 14.5 6.492 29 14.5 29zm4.243-20.157a1 1 0 011.414 1.414L15.914 14.5l4.243 4.243a1 1 0 01-1.414 1.414L14.5 15.914l-4.243 4.243a1 1 0 11-1.414-1.414l4.243-4.243-4.243-4.243a1 1 0 011.414-1.414l4.243 4.243 4.243-4.243z",
  fill: "#FF7D7D"
});

var SvgReportingKpiFailure = function SvgReportingKpiFailure(props) {
  return React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none"
  }, props), _ref);
};

export default SvgReportingKpiFailure;